// @flow

import { useController } from 'react-hook-form';
import {
  Checkbox as ReshapedCheckboxField,
  type FormControlProps,
} from 'reshaped';

import { FieldWrapper } from './FieldWrapper';

type Message = string;
type ValidateResult = Message | Message[] | boolean | void;

export type Props = {
  ...FormControlProps,
  name: string,
  /** https://react-hook-form.com/docs/usecontroller */
  control: any,
  label?: React.Node,
  help?: React.Node,
  rules?: {
    required?: string | boolean | { value: boolean, message?: Message },
    min?: number | { value: number, message?: Message },
    max?: number | { value: number, message?: Message },
    minLength?: number | { value: number, message?: Message },
    maxLength?: number | { value: number, message?: Message },
    pattern?: RegExp | { value: RegExp, message?: Message },
    validate?:
      | ((
          value: any,
          formValues: any,
        ) => ValidateResult | Promise<ValidateResult>)
      | { value: boolean, message?: Message },
  },
};

export function CheckboxField({
  name,
  label,
  help,
  disabled,
  control,
  rules,
  children,
  ...extraProps
}: Props): React.MixedElement {
  const { field, fieldState } = useController({
    name,
    control,
    rules,
  });

  return (
    <FieldWrapper
      fieldState={fieldState}
      label={label}
      help={help}
      {...extraProps}
    >
      <ReshapedCheckboxField
        name={field.name}
        // $FlowFixMe[incompatible-type]
        value={field.value}
        disabled={disabled}
        onChange={({ event }) => field.onChange(event)}
        size="large"
      >
        {children}
      </ReshapedCheckboxField>
    </FieldWrapper>
  );
}
